"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ObjectDelete_exports = {};
__export(ObjectDelete_exports, {
  default: () => ObjectDelete_default
});
module.exports = __toCommonJS(ObjectDelete_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.12164 5.4999C3.12164 4.06396 4.2857 2.8999 5.72164 2.8999H16.7216C18.1576 2.8999 19.3216 4.06396 19.3216 5.4999V11.9999C19.3216 12.3313 19.053 12.5999 18.7216 12.5999C18.3903 12.5999 18.1216 12.3313 18.1216 11.9999V5.4999C18.1216 4.7267 17.4948 4.0999 16.7216 4.0999H5.72164C4.94844 4.0999 4.32164 4.7267 4.32164 5.4999V16.4999C4.32164 17.2731 4.94844 17.8999 5.72164 17.8999H12.2216C12.553 17.8999 12.8216 18.1685 12.8216 18.4999C12.8216 18.8313 12.553 19.0999 12.2216 19.0999H5.72164C4.2857 19.0999 3.12164 17.9358 3.12164 16.4999V5.4999Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.5007 19.6242C14.2669 19.858 14.2677 20.2379 14.5025 20.4727C14.7373 20.7075 15.1172 20.7083 15.351 20.4745L17.5936 18.2319L19.8836 20.5218C20.1184 20.7566 20.4983 20.7574 20.7321 20.5236C20.9659 20.2898 20.9652 19.9099 20.7304 19.6751L18.4404 17.3851L20.7098 15.1157C20.9436 14.8819 20.9428 14.502 20.708 14.2672C20.4732 14.0324 20.0933 14.0316 19.8595 14.2654L17.5901 16.5348L15.3492 14.294C15.1144 14.0592 14.7346 14.0584 14.5007 14.2922C14.2669 14.526 14.2677 14.9059 14.5025 15.1407L16.7433 17.3816L14.5007 19.6242Z",
      fill: "currentColor"
    }
  )
);
const SvgObjectDelete = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ObjectDelete_default = SvgObjectDelete;
